import React from 'react';

import styles from './style.module.less';

export const RequiredIndicator = () => {
  return <span className={styles['required-indicator']}>&lowast;</span>;
};
